import { render, staticRenderFns } from "./createInvestors.vue?vue&type=template&id=11fcf64a"
import script from "./createInvestors.vue?vue&type=script&lang=js"
export * from "./createInvestors.vue?vue&type=script&lang=js"
import style0 from "./createInvestors.vue?vue&type=style&index=0&id=11fcf64a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports